import React from 'react';
import { JRCInputColorRaw } from './JRCInputColorRaw';
import { JRCInputColorRawProps } from './JRCInputColorRawProps';
import { FieldValues } from 'react-hook-form';
import { JRCFormFieldRenderer } from '../Common/JRCFormFieldRenderer';
import { JRCInputFieldProps } from '../Common/JRCFormFieldRenderer.types';

export type JRCColorPickerProps<T extends FieldValues> = Omit<JRCInputFieldProps<T>, 'placeholder' | 'labelIsLegend'> &
    Omit<JRCInputColorRawProps, 'onChange' | 'name' | 'description' | 'label'>;
export const JRCInputColor = <T extends FieldValues = FieldValues>({
    initialValue,
    palettes,
    disabled,
    ...props
}: JRCColorPickerProps<T>) => {
    return (
        <JRCFormFieldRenderer
            {...props}
            renderFunction={({ value, onChange }) => (
                <JRCInputColorRaw
                    name={props.name}
                    palettes={palettes}
                    onChange={onChange}
                    initialValue={value ?? initialValue}
                    disabled={disabled}
                />
            )}
        />
    );
};
